"use client";

import { Button, type ButtonProps } from "@/components/ui/button";
import { SaveButtonSpinner } from "@/components/save-button-spinner";
import { cn } from "@/lib/utils";

/** Keep the label stable while an adjacent spinner animates space in the row. */
export function SubscriptionActionButton({
  loading,
  wrapperClassName,
  statusIndicator,
  disabled,
  children,
  ...props
}: ButtonProps & {
  loading: boolean;
  wrapperClassName?: string;
  statusIndicator?: React.ReactNode;
}) {
  return (
    <span
      className={cn(
        "inline-flex min-w-0 items-center justify-end",
        wrapperClassName,
      )}
    >
      {statusIndicator ?? <SaveButtonSpinner show={loading} margin="right" />}
      <Button {...props} disabled={disabled || loading} aria-busy={loading}>
        {children}
      </Button>
    </span>
  );
}
